import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4cb66aa0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4cb66aa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb66aa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb66aa0')) {
      api.createRecord('4cb66aa0', component.options)
    } else {
      api.reload('4cb66aa0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4cb66aa0&scoped=true&", function () {
      api.rerender('4cb66aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/enshrineSetting/index.vue"
export default component.exports